import CommonIntroductionBase from "./common/CommonIntroductionBase";

const SocialEfficiency = () => {
  return (
    <CommonIntroductionBase
      slide="社会問題解決のための取り組み"
      collectionName="socialefficiency"
      postTitle="社会問題解決情報"
      targetItems={[
        "order",
        "eventday",
        "title",
        "content",
        "linkUrl",
        "youtubeUrl",
        "image",
      ]}
      enableMarkdown={true}
    />
  );
};

export default SocialEfficiency;
